angular
.module('app.views')
.controller('ConfirmTerminationController', function($scope, $modalInstance, Origin, broadcast_count, origin, total_viewer_count){
  $scope.broadcast_count = broadcast_count;
  $scope.origin = origin;
  $scope.total_viewer_count = total_viewer_count;
  $scope.confirm_origin_name = '';
  $scope.note = '';
  $scope.isWorking = false;

  $scope.dataValid = () => (!_.isEmpty($scope.note) && ($scope.confirm_origin_name === $scope.origin));

  $scope.ok = function() {
    $scope.isWorking = true;
    Origin.terminate(
      {id: $scope.origin},
      {user_note: $scope.note},
      (data) => {
        alert(`Origin "${$scope.origin}" has been terminated. Please check your email for further information.`);
        $modalInstance.close(data);
        $scope.isWorking = false;
      },
      (err) => {
        console.error(err);
        alert('There was an error terminating the origin.');
        $scope.isWorking = false;
      }
    );
  };

  return $scope.cancel = () => $modalInstance.dismiss('cancel');
});



// WEBPACK FOOTER //
// ./views/origins/confirm_termination_controller.js